
















































































import Vue from "vue";
import CopyrightComponent from "@/components/CopyrightComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
export default Vue.extend({
  components: {
    "copy-right": CopyrightComponent,
    "mytelnet-header": HeaderComponent
  }
})
